import React from "react";
//mui
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Avatar from "@mui/material/Avatar";
import { red } from "@mui/material/colors";

//狀態管理
import { observer } from "mobx-react";
import emissionViewStore from "../../../Store/marco/emissionViewStore";

//翻譯
import { useTranslation } from "react-i18next";

//main
const DataEntryDeleteModal = observer(() => {
  const store = emissionViewStore;
  const { t } = useTranslation("ActivityMain");

  if (!store.selectedDataEntry || !store.selectedDataEntryItem) return null;

  const id = store.selectedDataEntryItem.id;
  const name = store.selectedDataEntry.itemName;

  const handleDelete = async () => {
    try {
      const deleteSuccess = await store.deleteDE(id);

      if (!deleteSuccess) {
        return;
      }

      await store.getDEListData(
        store.authComArr,
        store.selectedYear,
        store.searchKeyword,
        store.selectedTab,
        store.selectedScope,
        store.standardId,
      );
      store._handleCloseDataEntryDeleteModal();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Dialog
      open={store.showDataEntryDeleteModal}
      onClose={() => store._handleCloseDataEntryDeleteModal()}
    >
      <DialogContent>
        <Stack
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Avatar sx={{ bgcolor: red[100], width: 56, height: 56 }}>
            <WarningRoundedIcon color="error" fontSize="large" />
          </Avatar>
          <DialogContentText id="alert-dialog-description">
            {t("Are you sure you want to delete") + " " + name}?
            <br />
            {t("This action will permanently delete files and data.")}
          </DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => store._handleCloseDataEntryDeleteModal()}
          variant="contained"
          disableElevation
          sx={{
            bgcolor: (theme) => theme.palette.grey[300],
            color: "black",
            textTransform: "none",
          }}
        >
          {t("Cancel")}
        </Button>
        <Button
          onClick={handleDelete}
          variant="outlined"
          color="error"
          sx={{ textTransform: "none" }}
        >
          {t("Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DataEntryDeleteModal;
